import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Stabilize viewport sizing on mobile/tablets (iOS Safari quirks)
function setupViewportSizingVariables() {
  const updateVars = () => {
    const appHeight = window.innerHeight;
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--app-height', `${appHeight}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
  updateVars();
  window.addEventListener('resize', updateVars, { passive: true });
  window.addEventListener('orientationchange', updateVars);
}

if (typeof window !== 'undefined') {
  setupViewportSizingVariables();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
